import { render, staticRenderFns } from "./doc_ret_guide.vue?vue&type=template&id=4d2828d6&scoped=true&"
import script from "./doc_ret_guide.vue?vue&type=script&lang=js&"
export * from "./doc_ret_guide.vue?vue&type=script&lang=js&"
import style0 from "./doc_ret_guide.vue?vue&type=style&index=0&id=4d2828d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2828d6",
  null
  
)

export default component.exports